export default class Accordions {
	constructor() {
		this.accordions = document.querySelectorAll(".schema-faq-section");
		if (this.accordions) {
			this.init();
		}
	}

	init() {
		this.accordions.forEach((item) => {
			const question = item.querySelector(".schema-faq-question");
			const answer = item.querySelector(".schema-faq-answer");

			question.addEventListener("click", () => {
				if (question.classList.contains("active")) {
					question.classList.remove("active");
					answer.style.display = "none";
				} else {
					question.classList.add("active");
					answer.style.display = "block";
				}
			});
		});
	}
}
